module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_17.f8f3cde8.pdf";